import Header from '@/components/components/Header';
import ContainerLayout from '@/components/Layout/ContainerLayout';
import { Paper } from '@/components/Paper';
import { useEffect, useRef, useState } from 'react';

import { Outlet, useLocation } from 'react-router-dom';
import { headers } from './settings';
import { useFetchList } from './service'; 
import { Spinner, Box, Icon } from '@chakra-ui/react';
import { WrapperTable } from '@/components/WrapperTable';
import Pagination from '@/components/Paginator';

import { MdFilterList } from 'react-icons/md';
import Filter from './Components/Filter';
import TabelaUsuario from './Components/Tabela';

function UsuarioList() {
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [visibleHeaders, setVisibleHeaders] = useState(headers);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const printRef = useRef(null);

  const [filters, setFilters] = useState({
    ativo: true,
    predio: "",
    andar: "",
    apartamento: "",
    rua: "",
    tipo: undefined,
  });

  const { data, isLoading } = useFetchList({
    page: currentPage - 1,
    size: 19,
    totalCount: 90,
    search: {}
  });

  useEffect(() => {
    if (data) {
      //@ts-ignore
      setTotalPages(data.data.qtdpaginas);
    }
  }, [data]);

  const handleDelete = (selectedData: any[]) => {

  };

    const handleFilterChange = (data: any) => {
      setFilters(data);
      setCurrentPage(1);
    };

  return (
    <ContainerLayout>
          <>
            <Paper
              m={6}
              bg="white"
              py={4}
              px={2}
              rounded="xl"
              shadow="sm"
              border="1px solid rgba(200, 200, 200, .4)"
              h={'94%'}
            >
      
                  <Header
                    onHeadersChange={setVisibleHeaders}
                    isFilterVisible={isFilterVisible}
                    headers={visibleHeaders}
                    isEyeEnabled
                    isMenuEnabled
                    onToggleFilter={() => setIsFilterVisible((prev) => !prev)}
                    onView={() => console.log('Visualizar ação executada')}
                    printRef={printRef}
                    title={'Cadastro de Usuários'}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    filterComponent={
                      <Filter onFilter={handleFilterChange}>
                        <Icon as={MdFilterList} boxSize={6} cursor="pointer" />
                      </Filter>
                    }
                  />

                  <WrapperTable  ref={printRef}>
                    {isLoading ? (
                      <Box py={10} textAlign="center">
                        <Spinner size="lg" />
                      </Box>
                    ) : (
                      <TabelaUsuario
                        headers={visibleHeaders}
                        onDelete={handleDelete}
                        //@ts-ignore
                        dados={data?.data }
                        valoPesquisa={searchTerm}
                      />
                      
                    )}
                  </WrapperTable>
                  <Pagination totalPages={totalPages} currentPage={currentPage} onPageChange={setCurrentPage}/>
            </Paper>
          </>
       <Outlet />
  
    </ContainerLayout>
  );
}

export default UsuarioList;
